<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row v-if="value.length">
		<b-col class="contraventions-wrapper">
			<!-- <h1 class="page-title" v-if="$store.state.isMobile">Violations</h1> -->
			<b-row v-for="(u, uindex) in value" :key="uindex">
			<b-col>
			<div class="contravention mb-3">
				<div>
					<b-row>
						<b-col lg="8">
								<div class="contravention__message" v-html="u.comments.value"></div>
								<div class="contravention__id">Violation ID: {{u.id}}</div>
								<div class="contravention__date">{{moment(u.createdDate).format('MMMM D, Y H:mm:ss')}}</div>
								<div class="contravention__name"><span>Enforcement Officer: </span>{{u.officer.firstName}} {{u.officer.lastName}}, {{u.officer.organizationName}}</div>
								<div v-if="u.createdBy" class="contravention__created-by"><span>Created By: </span>{{u.createdBy.firstName}} {{u.createdBy.lastName}}, {{u.createdBy.organizationName}}</div>
						</b-col>
						<b-col  class="text-lg-right pt-2 pt-sm-2 pt-lg-0">
							<b-button class="mr-2" type="button" @click="onSeeDetails(uindex)">See Details / Leave a Message</b-button>
						</b-col>
					</b-row>
				</div>
			</div>
			</b-col>
			</b-row>


		</b-col>
	</b-row>
</template>

<script>
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';
import Vue from 'vue';

export default {
	name: 'LaneClosureRequestContraventionList',

	components: {
	},

	props: ['value','lcrId', 'downloadToken', 'downloadTokenExpires', 'showEditButton'],
	data() {
		return {
			comments: new BootstrapField({
			}),
			replyToId: new BootstrapField({
			}),
		}
	},
	mounted() {
		this.setEventBusOn();
   },
   created() {
   },
   watch: {
   },
	computed: {
		canReportContravention: function() {
			return this.$store.getters.userCanReportContravention();
		}
	},
	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		setEventBusOff() {
			this.$bus.$off('message:newMessage', this.sendNewMessage);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('message:newMessage', this.sendNewMessage);
		},
		sendNewMessage(obj) {
			// "{id}/contravention/{contraventionId}/new-message
			if (obj.message != null && obj.message != "" ) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/message/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
					}).then(resp => {
						let x = 0;
						for (x = 0; x < this.value.length; x++) {
							if (this.value[x].id == obj.sourceId) {
								this.value[x].message.unshift(new LaneClosureRequestMessage(resp.data));
							}
						}

					this.PostNewMessageSuccess();
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						this.showErrors(error.response.data.fields);
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		PostNewMessageSuccess() {
		},

		SaveAttachmentComment(obj) {
			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments:obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
					}).then(resp => {

				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

		onSeeDetails(index) {
			if (this.canReportContravention) {
				this.onEditContravention(index);
			} else {
				this.onViewContravention(index);
			}
		},

		onViewContravention(index) {
			this.$bus.$emit("lane-closure-request:view-contravention", {
				id: this.value[index].id
			});
		},

		onEditContravention(index) {
			this.$bus.$emit("lane-closure-request:edit-contravention", {
				id: this.value[index].id
			});
		},
		onToggleExpand(uindex) {
			Vue.prototype.$bus.$emit("lane-closure-request:expand-contravention",{index:uindex,expand:!this.value[uindex].expand});
		},

	}
}
</script>
